<template>
  <div v-if="titles.length > 0">
    <p>设置表头</p>
    <div align="left">
      <div v-for="(x, index) in titles" :key="index" style="display: inline-block">
        <el-input @paste.native="pasteheader" @change="headerseting" v-model="titles[index]">
          <div slot="prepend">
            <el-checkbox @change="headerseting" v-model="typedateobj[titles[index]]">D</el-checkbox>
            <el-checkbox @change="headerseting" v-model="typenumberobj[titles[index]]">N</el-checkbox>
          </div>
          <div slot="append">
            <el-button size="mini" @click="removeit(index)">X</el-button>
          </div>
        </el-input>

      </div>
      <el-button style="display: inline-block;" type="warning" plain @click="addone">ADD</el-button>
    </div>

    <!-- <p>设置以下为日期格式</p>
      <el-checkbox-group @change="headerseting" v-model="typedate">
        <el-checkbox v-for="x in titles" :key="x" :label="x"></el-checkbox>
      </el-checkbox-group>

      <p>设置以下为数字格式</p>
      <el-checkbox-group @change="headerseting" v-model="typenumber">
        <el-checkbox v-for="x in titles" :key="x" :label="x"></el-checkbox>
      </el-checkbox-group>
      <br /> -->


  </div>
</template>

<script>
function getarr(objs, key) {
  let arr = [];
  objs.forEach((obj) => {
    arr.push(obj[key]);
  });
  return arr;
}

function randomLetter() {
  var letters = 'abcdefghijklmnopqrstuvwxyz';
  var randomNum = Math.round(Math.random() * 26);
  var randomLetter = letters.charAt(randomNum);
  return randomLetter;
};

export default {
  //   props: ["titles"],

  data() {
    return {
      titles: getarr(this.$store.state.currentheader, "title"),
      typedateobj: {},
      typenumberobj: {},
      //   typedate: [],
      //   typenumber: [],
    }
  },
  watch: {
    titles: {
      handler: function (newval, oldVal) {
        this.headerseting()
      },
      deep: true,
    },
  },
  computed: {

  },
  methods: {
    addone() {
      this.titles.push(randomLetter())
    },
    removeit(i) {
      this.titles.splice(i, 1)
    },
    pasteheader(event) {
      let str = event.clipboardData.getData("Text");
      //如果粘贴的字符中包含了"\t"且field的type不为json，那么对数据处理为对象值
      if (str.includes("\t")) {
        event.preventDefault();
      } else {
        return;
      }
      let line = str;
      let tempar = line.split("\t");
      this.titles = tempar.splice(0);
      //   this.headerseting()
    },
    headerseting() {
      let typedate = []
      let typenumber = []

      Object.entries(this.typedateobj).forEach(([key, value]) => {
        typedate.push(key)
      });

      Object.entries(this.typenumberobj).forEach(([key, value]) => {
        typenumber.push(key)
      });


      let header = {
        fields: this.titles,
        title: this.titles,
        type: {
          date: typedate,
          number: typenumber
        }
      };

      this.$emit("headerseted", header)

    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/exceltodb/defineddb_headerset.vue